import { ref, unref } from 'vue'
import { crudGroup, getPositions } from '@/apis/objectManage'
import {
  columnUseSceneEnums,
  dealFormConfig,
  useSceneTypeEnums
} from '@/utils/preObjectManage/utils'
import { fieldTypeConfig, moduleType, fieldTypeEnum } from '@/enums/preObjectManage'
import { formulaCalculation } from '@/utils/business/formulaCalculation'
import { getFieldFormulaConfig } from '@/utils/business/formulaEmitter'
import { cloneDeep } from '@/utils/tools'
import { isString } from '@/utils/is'
import EventEmitter from '@/utils/event'
import { QuoteMapping } from '@/utils/render/quoteMapping'

const visibleEmitter = new EventEmitter()
const equationEmitter = new EventEmitter()
const associaFormEmitter = new EventEmitter()

export function useDetail(props: Recordable) {
  const select = ref(0)
  // 定义一个公式计算的数据存储map
  const mapData: Recordable = {}
  const formData = ref<Recordable>({})
  const copyFormData = ref<Recordable>({})
  // 布局字段
  const positions = ref<Recordable[]>([])
  const showPositions = ref<Recordable[]>([])
  // 如果是上下布局
  const singlePositionData = ref<Recordable[]>([])
  const positionInfo = ref<Recordable>({})
  const tableInfo = ref<Recordable>({})

  // 所有分栏中字段id
  const subFieldIds = ref<string[]>([])
  //  所有分栏中字段Serial
  const columnSerials = ref<string[]>([])

  // 系统信息
  const systemInfoList = ref<Recordable[]>([])
  // 配置了公式的字段容器
  const equationList = ref<Recordable[]>([])

  // 引用映射类
  const quoteMappingConfig = new QuoteMapping()

  // 分栏字段中的数据
  const subFieldFormData = ref<Recordable>({})

  // 字段的显隐
  const visibleBox = ref<Recordable[]>([])
  const layoutVisibleBox = ref<Recordable[]>([])
  // 布局的显隐配置
  const layoutVisibleSettingBox = ref<Recordable[]>([])
  // 关联表单条件容器
  const associaFormCondition = ref<Recordable[]>([])

  // 获取详情布局
  function getDetailLayout() {
    visibleBox.value = []
    layoutVisibleBox.value = []
    getPositions({
      tableCode: props.tableCode,
      type: 10,
      ignoreDataScope: true
    }).then((res: Recordable) => {
      layoutVisibleSettingBox.value = res.visibleList || []
      positions.value = res.positions
      positionInfo.value = res.positionInfo
      tableInfo.value = res.tableInfo
      const layout = unref(positionInfo)?.layout
        ? JSON.parse(unref(positionInfo).layout)
        : { select: 1 }
      select.value = layout.select || 1
      setAllId()
      // initForm()
    })
  }
  // 设置所有分栏字段和子表字段
  function setAllId() {
    const arr1: string[] = []
    const arr3: string[] = []
    positions.value.forEach((container: Recordable) => {
      if (container.code === 'BLANK') {
        container.modules.forEach((module: Recordable) => {
          module.componentList.forEach((field: Recordable) => {
            const { id, fieldSerial } = field.columnInfo
            if (module.moduleType === moduleType.subField) {
              id && arr1.push(id)
              fieldSerial && arr3.push(fieldSerial)
            }
          })
        })
      }
      if (container.code === 'TABLE') {
        container.children.forEach((child: Recordable) => {
          child.modules.forEach((module: Recordable) => {
            module.componentList.forEach((field: Recordable) => {
              const { id, fieldSerial } = field.columnInfo
              if (module.moduleType === moduleType.subField) {
                id && arr1.push(id)
                arr3.push(fieldSerial)
              }
            })
          })
        })
      }
    })
    // 分栏所有的id
    subFieldIds.value = arr1
    columnSerials.value = arr3
    // 获取所有分栏中字段对应的数据
    crudGroup({
      columns: subFieldIds.value,
      columnSerials: columnSerials.value,
      tableCode: props.tableCode,
      queryType: 1,
      type: 3,
      dataId: props.id,
      ignoreDataScope: true
    }).then(res => {
      subFieldFormData.value = res || {}
      systemInfoList.value = res?.systemInfo || []
      initForm()
    })
  }
  // 初始化表单
  function initForm() {
    const cloneData = cloneDeep([...unref(positions)])
    positions.value = cloneData.map((container: Recordable) => {
      if (container.code === 'BLANK') {
        container.modules = container.modules.map((module: Recordable) => {
          // 排序
          module.componentList.sort((a: any, b: any) => {
            const layoutX = a.layout ? (isString(a.layout) ? JSON.parse(a.layout) : a.layout) : {}
            const positionX = layoutX.position
            const layoutY = b.layout ? (isString(b.layout) ? JSON.parse(b.layout) : b.layout) : {}
            const positionY = layoutY.position
            // 首先按照 x 从小到大排序
            if (positionX?.x !== positionY?.x) {
              return positionX?.x - positionY?.x
            }
            // 如果 x 相同，则按照 y 从小到大排序
            return positionX?.y - positionY?.y
          })

          const componentList = module.componentList.filter((field: any) =>
            getIsShow(field.columnInfo.fieldSerial, props.columnPermission)
          )
          module.componentList = componentList.map((field: Recordable) => {
            const {
              code,
              fieldCode,
              fieldType,
              fieldSerial,
              visibleRuleList,
              defaultMark,
              setting
            } = field.columnInfo

            if (defaultMark === 2) {
              const settingData = getFieldFormulaConfig(setting)
              if (settingData.web.equation) {
                equationList.value.push(field)
              }
            }
            mapData[fieldSerial] = subFieldFormData.value?.[fieldCode]
            field.layout = isString(field.layout) ? JSON.parse(field.layout) : field.layout
            const propsValue = props.columnValues[fieldCode] || props.columnValues[fieldSerial]
            const sensitiveValue =
              subFieldFormData.value?.sensitiveValues &&
              subFieldFormData.value?.sensitiveValues[fieldCode]?.originalValue
            const defaultValue: any =
              (propsValue || sensitiveValue || subFieldFormData.value?.[fieldCode])?.toString() ||
              ''
            // 客户标签特殊处理转为数组
            const toArrayCodes = [
              fieldTypeConfig.tags,
              fieldTypeConfig.picture,
              fieldTypeConfig.enclosure
            ]
            formData.value[fieldCode] = toArrayCodes.includes(code)
              ? parseValue(defaultValue)
              : defaultValue
            // 默认值为单行文本
            let customCode = code
            // 引用字段
            if (
              fieldType === fieldTypeEnum.SYS_QUOTE ||
              fieldType === fieldTypeEnum.CUSTOM_QUOTE ||
              fieldType === fieldTypeEnum.SON_SYS_QUOTE ||
              fieldType === fieldTypeEnum.SON_CUSTOM_QUOTE
            ) {
              customCode = fieldTypeConfig.quote
            }
            // 映射字段
            if (
              fieldType === fieldTypeEnum.SYS_MAPPING ||
              fieldType === fieldTypeEnum.CUSTOM_MAPPING ||
              fieldType === fieldTypeEnum.SON_SYS_MAPPING ||
              fieldType === fieldTypeEnum.SON_CUSTOM_MAPPING
            ) {
              customCode = fieldTypeConfig.mapping
            }

            // 取出下拉单选和单选按钮的显隐规则
            if (code === fieldTypeConfig.radio || code === fieldTypeConfig.select) {
              // 如果设置的显隐规则，就需要注册监听事件
              if (visibleRuleList && visibleRuleList.length) {
                visibleRuleList.forEach((item: Recordable<any>) => {
                  if (item.actionCode === 'COLUMN') {
                    visibleBox.value.push({
                      ...item,
                      show: defaultValue === item.value
                    })
                  } else if (item.actionCode === 'LAYOUT') {
                    layoutVisibleBox.value.push({
                      ...item,
                      show: defaultValue === item.value
                    })
                  }
                })
              }
              if (layoutVisibleSettingBox.value.length) {
                layoutVisibleSettingBox.value.forEach(item => {
                  const cur = layoutVisibleBox.value.find(box => box.value === item.value)
                  if (!cur) {
                    layoutVisibleBox.value.push({
                      ...item,
                      show: String(formData.value[fieldCode]) === item.value
                    })
                  } else {
                    cur.show = cur.show || String(formData.value[fieldCode]) === item.value
                  }
                })
              }
            }

            const strategyFn =
              dealFormConfig[customCode] || dealFormConfig[fieldTypeConfig.singleLineText]
            const renderConfig = strategyFn(
              { ...field, ...field.columnInfo },
              {
                tableColumnType: module.moduleType
              },
              quoteMappingConfig
            )

            // 给每个字段绑定一个显隐的事件
            renderConfig.visibleEmitter = visibleEmitter
            // 给每个字段绑定一个公式计算的事件
            renderConfig.equationEmitter = equationEmitter

            return {
              ...field,
              ...field.columnInfo,
              isTxt: getIsTxt(field.columnInfo.fieldSerial, props.columnPermission),
              renderConfig: {
                ...renderConfig,
                disabled: getIsTxt(field.columnInfo.fieldSerial, props.columnPermission),
                required: getIsRequired(field.columnInfo.fieldSerial, props.columnPermission)
              },
              columnUseScene: columnUseSceneEnums.processDetailPage,
              useSceneType: useSceneTypeEnums.paas,
              getByTagIdFlag: true
            }
          })

          // 处理关联表单的条件
          if (module.moduleType === moduleType.subForm) {
            // associaFormCondition
            const conditionInfo = module.conditionInfo
            if (conditionInfo && conditionInfo?.conditionList) {
              const columnSerials: string[] = []
              conditionInfo.conditionList.forEach((condition: { conditions: any[] }) => {
                condition.conditions.forEach(condi => {
                  if (condi.rightType === 10) {
                    columnSerials.push(condi.rightColumnSerial)
                  }
                })
              })
              associaFormCondition.value.push({
                moduleSerial: module.moduleSerial,
                Emitter: associaFormEmitter,
                columnSerials
              })
            }
          }

          return {
            ...module,
            visibleEmitter, // 控制分栏，子表，关联表单的显隐
            associaFormEmitter
          }
        })
      }
      if (container.code === 'TABLE') {
        container.children.sort((a: any, b: any) => {
          const layoutA = a.layout ? (isString(a.layout) ? JSON.parse(a.layout) : a.layout) : {}
          const positionA = layoutA.position
          const layoutB = b.layout ? (isString(b.layout) ? JSON.parse(b.layout) : b.layout) : {}
          const positionB = layoutB.position
          return positionA?.x - positionB?.x
        })
        container.children = container.children.map((child: Recordable) => {
          child.modules = child.modules.map((module: Recordable) => {
            module.componentList.sort((a: any, b: any) => {
              const layoutX = a.layout ? (isString(a.layout) ? JSON.parse(a.layout) : a.layout) : {}
              const positionX = layoutX.position
              const layoutY = b.layout ? (isString(b.layout) ? JSON.parse(b.layout) : b.layout) : {}
              const positionY = layoutY.position
              // 首先按照 x 从小到大排序
              if (positionX?.x !== positionY?.x) {
                return positionX?.x - positionY?.x
              }
              // 如果 x 相同，则按照 y 从小到大排序
              return positionX?.y - positionY?.y
            })
            const componentList = module.componentList.filter((field: any) =>
              getIsShow(field.columnInfo.fieldSerial, props.columnPermission)
            )
            module.componentList = componentList.map((field: Recordable) => {
              const {
                code,
                fieldCode,
                fieldType,
                fieldSerial,
                visibleRuleList,
                defaultMark,
                setting
              } = field.columnInfo

              if (defaultMark === 2) {
                const settingData = getFieldFormulaConfig(setting)
                if (settingData.web.equation) {
                  equationList.value.push(field)
                }
              }
              mapData[fieldSerial] = subFieldFormData.value?.[fieldCode]
              field.layout = isString(field.layout) ? JSON.parse(field.layout) : field.layout
              // 后期再去区别分栏和子表
              const propsValue = props.columnValues[fieldCode] || props.columnValues[fieldSerial]
              const sensitiveValue =
                (subFieldFormData.value?.sensitiveValues &&
                  subFieldFormData.value?.sensitiveValues[fieldCode]?.originalValue) ||
                ''
              const defaultValue: any =
                (propsValue || sensitiveValue || subFieldFormData.value?.[fieldCode])?.toString() ||
                ''
              // 客户标签特殊处理转为数组
              // 客户标签特殊处理转为数组
              const toArrayCodes = [
                fieldTypeConfig.tags,
                fieldTypeConfig.picture,
                fieldTypeConfig.enclosure
              ]
              formData.value[fieldCode] = toArrayCodes.includes(code)
                ? parseValue(defaultValue)
                : defaultValue
              // formData.value[fieldCode] = code === fieldTypeConfig.tags ? parseValue(defaultValue) : defaultValue
              let customCode = code
              // 引用字段
              if (
                fieldType === fieldTypeEnum.SYS_QUOTE ||
                fieldType === fieldTypeEnum.CUSTOM_QUOTE ||
                fieldType === fieldTypeEnum.SON_SYS_QUOTE ||
                fieldType === fieldTypeEnum.SON_CUSTOM_QUOTE
              ) {
                customCode = fieldTypeConfig.quote
              }
              // 映射字段
              if (
                fieldType === fieldTypeEnum.SYS_MAPPING ||
                fieldType === fieldTypeEnum.CUSTOM_MAPPING ||
                fieldType === fieldTypeEnum.SON_SYS_MAPPING ||
                fieldType === fieldTypeEnum.SON_CUSTOM_MAPPING
              ) {
                customCode = fieldTypeConfig.mapping
              }

              // 取出下拉单选和单选按钮的显隐规则
              if (code === fieldTypeConfig.radio || code === fieldTypeConfig.select) {
                // 如果设置的显隐规则，就需要注册监听事件
                if (visibleRuleList && visibleRuleList.length) {
                  visibleRuleList.forEach((item: Recordable<any>) => {
                    if (item.actionCode === 'COLUMN') {
                      visibleBox.value.push({
                        ...item,
                        show: defaultValue === item.value
                      })
                    } else if (item.actionCode === 'LAYOUT') {
                      layoutVisibleBox.value.push({
                        ...item,
                        show: defaultValue === item.value
                      })
                    }
                  })
                }
                if (layoutVisibleSettingBox.value.length) {
                  layoutVisibleSettingBox.value.forEach(item => {
                    const cur = layoutVisibleBox.value.find(box => box.value === item.value)
                    if (!cur) {
                      layoutVisibleBox.value.push({
                        ...item,
                        show: String(formData.value[fieldCode]) === item.value
                      })
                    } else {
                      cur.show = cur.show || String(formData.value[fieldCode]) === item.value
                    }
                  })
                }
              }

              // 默认值为单行文本
              const strategyFn =
                dealFormConfig[customCode] || dealFormConfig[fieldTypeConfig.singleLineText]
              const renderConfig = strategyFn(
                { ...field, ...field.columnInfo },
                {
                  tableColumnType: module.moduleType
                },
                quoteMappingConfig
              )

              // 给每个字段绑定一个显隐的事件
              renderConfig.visibleEmitter = visibleEmitter
              // 给每个字段绑定一个公式计算的事件
              renderConfig.equationEmitter = equationEmitter

              return {
                ...field,
                ...field.columnInfo,
                isTxt: getIsTxt(field.columnInfo.fieldSerial, props.columnPermission),
                renderConfig: {
                  ...renderConfig,
                  disabled: getIsTxt(field.columnInfo.fieldSerial, props.columnPermission),
                  required: getIsRequired(field.columnInfo.fieldSerial, props.columnPermission)
                },
                columnUseScene: columnUseSceneEnums.processDetailPage,
                useSceneType: useSceneTypeEnums.paas,
                getByTagIdFlag: true
              }
            })

            // 处理关联表单的条件
            if (module.moduleType === moduleType.subForm) {
              // associaFormCondition
              const conditionInfo = module.conditionInfo
              if (conditionInfo && conditionInfo?.conditionList) {
                const columnSerials: string[] = []
                conditionInfo.conditionList.forEach((condition: { conditions: any[] }) => {
                  condition.conditions.forEach(
                    (condi: { rightType: number; rightColumnSerial: string }) => {
                      if (condi.rightType === 10) {
                        columnSerials.push(condi.rightColumnSerial)
                      }
                    }
                  )
                })
                associaFormCondition.value.push({
                  moduleSerial: module.moduleSerial,
                  Emitter: associaFormEmitter,
                  columnSerials
                })
              }
            }
            return {
              ...module,
              visibleEmitter, // 控制分栏，子表，关联表单的显隐
              associaFormEmitter
            }
          })
          return {
            ...child
          }
        })
      }
      return {
        ...container
      }
    })
    positions.value.sort((a, b) => {
      const layoutA = a.layout ? (isString(a.layout) ? JSON.parse(a.layout) : a.layout) : {}
      const positionA = layoutA.position
      const layoutB = b.layout ? (isString(b.layout) ? JSON.parse(b.layout) : b.layout) : {}
      const positionB = layoutB.position
      return positionA?.x - positionB?.x
    })

    const index = positions.value.findIndex(item => {
      const layout = item.layout
        ? isString(item.layout)
          ? JSON.parse(item.layout)
          : item.layout
        : {}
      if (layout.top) {
        return true
      }
    })
    if (index !== -1) {
      singlePositionData.value = [positions.value[index]]
      positions.value.splice(index, 1)
    }
    showPositions.value = positions.value
    copyFormData.value = cloneDeep(JSON.parse(JSON.stringify(formData.value)))

    dealVisible()
  }

  function dealVisible() {
    const showLayout: string[] = []
    const showField: string[] = []
    // 已经设置了true之后就不用再去设置了

    // 跟进显隐规则隐藏对应的字段
    showPositions.value.forEach(container => {
      if (container.code === 'BLANK') {
        container.modules.forEach((module: Recordable) => {
          let layoutFlag = false
          layoutVisibleBox.value.forEach(visible => {
            const actionSerial = visible.actionSerial.split(',')
            if (actionSerial.indexOf(module.moduleSerial) !== -1 && visible.show) {
              const cur = showLayout.find(showItem => showItem === module.moduleSerial)
              if (!cur) {
                showLayout.push(module.moduleSerial)
              }
            }
          })
          layoutFlag = layoutVisibleBox.value.every(visible => {
            const flag = true
            const actionSerial = visible.actionSerial.split(',')
            if (actionSerial.indexOf(module.moduleSerial) !== -1) {
              return false
            }
            return flag
          })
          module.visibleEmitter.on(`detailVisible_${module.moduleSerial}`, (show: boolean) => {
            module.show = show
          })
          // 已经包含则为true，或者没有配置该分栏也应为true
          module.show = showLayout.includes(module.moduleSerial) || layoutFlag

          module.componentList.forEach((field: Recordable) => {
            let fieldFlag = false
            visibleBox.value.forEach(visible => {
              const actionSerial = visible.actionSerial.split(',')
              if (actionSerial.indexOf(field.fieldSerial) !== -1 && visible.show) {
                const cur = showField.find(showItem => showItem === module.moduleSerial)
                if (!cur) {
                  showField.push(field.fieldSerial)
                }
              }
            })
            fieldFlag = visibleBox.value.every(visible => {
              const flag = true
              const actionSerial = visible.actionSerial.split(',')
              if (actionSerial.indexOf(field.fieldSerial) !== -1) {
                return false
              }
              return flag
            })

            field.renderConfig.visibleEmitter.on(
              `detailVisible_${field.fieldSerial}`,
              (show: boolean) => {
                // 隐藏字段后要在计算中去掉
                if (!show) {
                  delete mapData[field.fieldSerial]
                }
                field.show = show
              }
            )
            field.show = showField.includes(field.fieldSerial) || fieldFlag
            // 处理计算公式
            if (field.defaultMark === 2) {
              formulaCalculation(module, field, formData, mapData)
            }
          })
        })
      }
      if (container.code === 'TABLE') {
        container.children.forEach((child: Recordable) => {
          child.modules.forEach((module: Recordable) => {
            let layoutFlag = false
            layoutVisibleBox.value.forEach(visible => {
              const actionSerial = visible.actionSerial.split(',')
              if (actionSerial.indexOf(module.moduleSerial) !== -1 && visible.show) {
                const cur = showLayout.find(showItem => showItem === module.moduleSerial)
                if (!cur) {
                  showLayout.push(module.moduleSerial)
                }
              }
            })
            layoutFlag = layoutVisibleBox.value.every(visible => {
              const flag = true
              const actionSerial = visible.actionSerial.split(',')
              if (actionSerial.indexOf(module.moduleSerial) !== -1) {
                return false
              }
              return flag
            })
            module.visibleEmitter.on(`detailVisible_${module.moduleSerial}`, (show: boolean) => {
              module.show = show
            })
            module.show = showLayout.includes(module.moduleSerial) || layoutFlag
            module.componentList.forEach((field: Recordable) => {
              let fieldFlag = false
              visibleBox.value.forEach(visible => {
                const actionSerial = visible.actionSerial.split(',')
                if (actionSerial.indexOf(field.fieldSerial) !== -1 && visible.show) {
                  const cur = showField.find(showItem => showItem === module.moduleSerial)
                  if (!cur) {
                    showField.push(field.fieldSerial)
                  }
                }
              })
              fieldFlag = visibleBox.value.every(visible => {
                const flag = true
                const actionSerial = visible.actionSerial.split(',')
                if (actionSerial.indexOf(field.fieldSerial) !== -1) {
                  return false
                }
                return flag
              })
              field.renderConfig.visibleEmitter.on(
                `detailVisible_${field.fieldSerial}`,
                (show: boolean) => {
                  // 隐藏字段后要在计算中去掉
                  if (!show) {
                    delete mapData[field.fieldSerial]
                  }
                  field.show = show
                }
              )
              field.show = showField.includes(field.fieldSerial) || fieldFlag
              // 处理计算公式
              if (field.defaultMark === 2) {
                formulaCalculation(module, field, formData, mapData)
              }
            })
          })
        })
      }
    })
    singlePositionData.value.forEach(container => {
      if (container.code === 'BLANK') {
        container.modules.forEach((module: Recordable) => {
          let layoutFlag = false
          layoutVisibleBox.value.forEach(visible => {
            const actionSerial = visible.actionSerial.split(',')
            if (actionSerial.indexOf(module.moduleSerial) !== -1 && visible.show) {
              const cur = showLayout.find(showItem => showItem === module.moduleSerial)
              if (!cur) {
                showLayout.push(module.moduleSerial)
              }
            }
          })
          layoutFlag = layoutVisibleBox.value.every(visible => {
            const flag = true
            const actionSerial = visible.actionSerial.split(',')
            if (actionSerial.indexOf(module.moduleSerial) !== -1) {
              return false
            }
            return flag
          })
          module.visibleEmitter.on(`detailVisible_${module.moduleSerial}`, (show: boolean) => {
            module.show = show
          })
          // 已经包含则为true，或者没有配置该分栏也应为true
          module.show = showLayout.includes(module.moduleSerial) || layoutFlag

          module.componentList.forEach((field: Recordable) => {
            let fieldFlag = false
            visibleBox.value.forEach(visible => {
              const actionSerial = visible.actionSerial.split(',')
              if (actionSerial.indexOf(field.fieldSerial) !== -1 && visible.show) {
                const cur = showField.find(showItem => showItem === module.moduleSerial)
                if (!cur) {
                  showField.push(field.fieldSerial)
                }
              }
            })
            fieldFlag = visibleBox.value.every(visible => {
              const flag = true
              const actionSerial = visible.actionSerial.split(',')
              if (actionSerial.indexOf(field.fieldSerial) !== -1) {
                return false
              }
              return flag
            })
            field.renderConfig.visibleEmitter.on(
              `detailVisible_${field.fieldSerial}`,
              (show: boolean) => {
                // 隐藏字段后要在计算中去掉
                if (!show) {
                  delete mapData[field.fieldSerial]
                }
                field.show = show
              }
            )
            field.show = showField.includes(field.fieldSerial) || fieldFlag
            // 处理计算公式
            if (field.defaultMark === 2) {
              formulaCalculation(module, field, formData, mapData)
            }
          })
        })
      }
    })
  }

  // 重置表单数据
  function resetFormData() {
    formData.value = cloneDeep(JSON.parse(JSON.stringify(copyFormData)))
    initForm()
  }

  // 判断是否为只读
  function getIsTxt(id: string, columnPermission: any) {
    // ['READ', 'WRITE', 'REQUIRED']
    if (columnPermission[id]) {
      if (columnPermission[id].includes('WRITE') || columnPermission[id].includes('REQUIRED')) {
        return false
      }
    }
    return true
  }
  // 判断是的为必填
  function getIsRequired(id: string, columnPermission: any) {
    // ['READ', 'WRITE', 'REQUIRED']
    if (columnPermission[id]) {
      if (columnPermission[id].includes('REQUIRED')) {
        return true
      }
    }
    return false
  }
  // 是否展示此字段
  function getIsShow(id: string, columnPermission: any) {
    if (props.showAll) return true
    return columnPermission && columnPermission[id]?.length
  }
  // 标签value转为数组
  function parseValue(value: string) {
    let arr = []
    if (!value) return
    try {
      const t = JSON.parse(value)
      if (t instanceof Array) {
        arr = t
      } else {
        arr = value.toString().split(',')
      }
    } catch (e) {
      arr = value.toString().split(',')
    }
    return arr
  }

  function stringifyValue(value: any) {
    return JSON.stringify(value)
  }
  return {
    initForm,
    getDetailLayout,
    formData,
    select,
    resetFormData,
    singlePositionData,
    showPositions,
    systemInfoList,
    copyFormData,
    quoteMappingConfig,
    parseValue,
    stringifyValue,
    equationList,
    visibleBox,
    layoutVisibleBox,
    subFieldFormData,
    associaFormCondition
  }
}
